export class Usuario{
    public constructor(
        public tipo_dni:String = "",
        public dni:String = "",
        public nombres:String = "",
        public apellido_paterno:String = "",
        public apellido_materno:String = "",
        public direccion:String = "",
        public telefono:String = "",
        public email:String = "",
        public id:String = "",
        public usuario:String = "",
        public clave:String = "",
        public perfil_id:String = "",
        public persona_id:String = "",
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public usuario_id:String = null
        
    ){}

}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/usuario.ts